import '@bigyellow/assets/css/icofont.min.css'
import '@bigyellow/assets/css/responsive.scss'
import 'react-toastify/dist/ReactToastify.css'
import '@bigyellow/assets/css/bigyellow.scss'

import App from 'next/app'
import { DefaultSeo } from 'next-seo'
import axios from 'axios'
import Head from 'next/head'

import { createStore } from '@bigyellow/store'

import Loader from '@bigyellow/components/Shared/Loader'

import { getItem, setItem } from '@bigyellow/libs/storage'
import { toast, ToastContainer, Zoom } from 'react-toastify'
import { redirect } from '@bigyellow/libs/redirect'
import { SIGNIN, SIGNOUT } from '@bigyellow/routes'
import React from 'react'

import registerIcons from '@bigyellow/modules/register-icons'

import { AnimatePresence } from 'framer-motion'

import getConfig from 'next/config'
import ErrorBoundary from '@bigyellow/components/ErrorBoundary'

registerIcons()

class BigYellow extends App {
  static async getInitialProps ({ Component, ctx }) {
    return {
      pageProps: Component.getInitialProps
        ? await Component.getInitialProps(ctx)
        : {}
    }
  }

  state = {
    loading: true
  }

  componentDidMount () {
    this.setState({
      loading: false
    })
  }

  componentDidUpdate () {
    this.updatePageBodyClassName()

    getItem('user').then(res => {
      if (res === null || typeof res?.id === 'undefined') {
        const pathname = document.location.pathname
        const re = new RegExp(/(signin|forgot-password|signup|signout|site-maintenance)/)
        const path = pathname.match(re)
        if (path === null && pathname !== '/') {
          getItem('flashmessage').then(res => {
            if (!res) {
              setItem('flashmessage', {
                'message': 'You have been logged out. Please log back in',
                'type': 'error'
              })
            }
            redirect(SIGNIN)
          })
        }
      }
    })
  }

  /**
   * adds class names to the body of the page according to the page path
   */
  updatePageBodyClassName = () => {
    const pageUrl = this.props.router.route
    const sections = pageUrl.split('/')
    if (pageUrl === '/') {
      sections.push('myaccount')
    }
    let newClassName = ''
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i]
      if (section.length > 0) {
        newClassName += section
        //add space if its not the last class
        newClassName += sections.length > i + 1 ? ' ' : ''
      }
    }
    if (newClassName !== document.body.className) {
      document.body.className = newClassName
    }
  }

  componentWillUnmount () {}

  render () {
    const { Component, pageProps } = this.props

    return (
      <React.Fragment>
        <ErrorBoundary>
          <DefaultSeo
            title="Big Yellow Self Storage"
            description="Storage made easy. Home and business storage units. 50% off for 8 weeks. Get a price online. The UK’s favourite choice. The UK’s secure choice. Big Yellow."
            openGraph={{
              type: 'website',
              locale: 'en_IE',
              url: '#',
              site_name: 'Big Yellow Self Storage'
            }}
          />
          <Head>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=yes"
            />
          </Head>

          <AnimatePresence exitBeforeEnter>
            <Component {...pageProps} key={'13'} />
            <Loader loading={this.state.loading} key={'14'} />
            <ToastContainer position="bottom-left" key={'15'} />
            {/*<GoTop scrollStepInPx="50" delayInMs="16.66" key={'16'} />*/}
          </AnimatePresence>
        </ErrorBoundary>
      </React.Fragment>
    )
  }
}

const { publicRuntimeConfig } = getConfig()

let axios_headers = {
  //all axios can be used, shown in axios documentation
  baseURL: publicRuntimeConfig.apiUrl ?? 'http://127.0.0.1:8080/api/v1',
  responseType: 'json',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    //'Accept-Language': 'en',
    //'Authorization': '',
    'X-Api-Key': publicRuntimeConfig.apiKey ?? ''
  }
}

const client = axios.create(axios_headers)

client.interceptors.response.use((res) => {
  return res
}, (error) => {

  if (error.response && (error.response.status === 403 || error.response.status === 401)) {

    //ignore signout and signin routes
    const pathname = document.location.pathname
    const re = new RegExp(/(signin|forgot-password|signup|signout|site-maintenance)/)
    const path = pathname.match(re)
    if (path !== null) {
      return Promise.reject(error)
    }
    //get the message
    const message = error?.response?.data?.message

    setItem('flashmessage', {
      'message': message?message:'You have been logged out. Please log back in',
      'type': 'error'
    })

    setItem('alreadySignedOut', true)
    redirect(SIGNOUT)
  }

  return Promise.reject(error)
})

const initialStoreValues = {
  http_client: client,
  notify: (content, options) => {
    // do your stuff

    const new_options = {
      type: options?.type ?? 'error',
      transition: Zoom,
      position: 'top-center',
      autoClose: false,
      hideProgressBar: false,
      pauseOnHover: false,
      draggable: true,
      progress: undefined
    }
    let toastReactText = toast(content, new_options)
    document.querySelectorAll('input').forEach(input => {
      input.addEventListener('input', () => {
        toast.dismiss();
      });
    });

    return toastReactText
  },

  token: null,
  user: {
    first_name: null,
    last_name: null
  }
}

export default createStore(BigYellow, initialStoreValues)
